import {get} from './utils';

export default function GetColours(el) {
  const handles = el.dataset.colours;

  get(`/search?type=product&q=${handles}&section_id=colours-query`)
    .then(response => response.text())
    .then(data => {
      el.innerHTML = data;
    })
    .catch(error => console.warn(error));
}

